module.exports = __webpack_public_path__ + "static/FEMA_logo-0c2c4637a703d0ebbd2272876ef4165d.svg";